import { dateTimeUtils } from '@cocoonspace/shared/utils/date-time-utils'

export const getWeekdayFromDate = (date: string) =>
	dateTimeUtils(date).locale('en').format('ddd').toLowerCase()
